import type { Coach, CourseItemType, Form, Product, ProductType, WorkflowType } from '@coursera/event-pulse-types';
import { createTrackerStore } from '@coursera/event-pulse/react';

export type CoachTrackingData = {
  data: {
    courseId?: string;
    itemId?: string;
    degreeId?: string;
    mode: string;
    location?: Coach['location'];
    itemType?: CourseItemType;
    form?: Form;
    courseBuilderWorkflowId?: string;
    courseBuilderWorkflowType?: { workflowType: WorkflowType };
  };
};

const [CoachTrackingDataProvider, useCoachTrackingContext] = createTrackerStore<CoachTrackingData>();

export { CoachTrackingDataProvider, useCoachTrackingContext };

const PRODUCT_TYPES: ProductType[] = [
  'course',
  's12n',
  'degree',
  'premium_certificate',
  'clip',
  'cplus',
  'clite',
  'guided_project',
  'master_track',
  'project',
  'learning_path',
  'custom_course',
  'xdp_series',
];

// Course and specialization IDs are 22 characters; versioned specializations add a child~ prefix
const COURSE_OR_S12N_ID_REGEX = /^(child~)?[A-Za-z0-9_-]{22}$/;

/**
 * Product recommendation links in coach responses carry a model-written productId/productType, which can be
 * truncated or placeholder values. Only return a product for eventing when it looks like a real product.
 */
export const getCoachRecommendedProduct = (
  productId: string | null,
  productType: string | null
): Product | undefined => {
  const type = PRODUCT_TYPES.find((productTypeOption) => productTypeOption === productType);
  if (!productId || !type) {
    return undefined;
  }
  if ((type === 'course' || type === 's12n') && !COURSE_OR_S12N_ID_REGEX.test(productId)) {
    return undefined;
  }
  return { id: productId, type };
};
